module.exports = __webpack_public_path__ + "static/img/play-text.203eee80.png";